import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appLoadingButton]',
})
export class LoadingButtonDirective implements AfterViewInit, OnChanges {
  @Input() loadingState: boolean;
  @Input() disabled: boolean; // Ensure we take into account the disabled state
  loading: boolean = false;
  widthParent: number = 0;
  contentText: string;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit(): void {
    if (!this.loading) {
      this.contentText = this.elementRef.nativeElement.innerHTML;
      this.widthParent = this.elementRef.nativeElement.clientWidth;
      this.loading = true;
      this.ngOnChanges();
    }
  }

  ngOnChanges(): void {
    if (this.loading) {
      if (this.loadingState) {
        // When loading is active
        this.elementRef.nativeElement.style.width = `${this.widthParent}px`;
        this.elementRef.nativeElement.innerHTML = '<div class="spin-loader"></div>';
        this.elementRef.nativeElement.disabled = true; // Always disable when loading
        this.elementRef.nativeElement.style.cursor = 'default'; // Cursor should always be default during loading
      } else {
        // When not loading, restore the content
        this.elementRef.nativeElement.innerHTML = this.contentText;

        // Re-enable button if it wasn't disabled by the template
        if (!this.disabled) {
          this.elementRef.nativeElement.disabled = false;
          this.elementRef.nativeElement.style.cursor = 'pointer'; // Set cursor to pointer when not disabled
        } else {
          this.elementRef.nativeElement.style.cursor = 'default'; // Ensure cursor is default when disabled by template
        }
      }
    }
  }
}
